import { Controller } from "@hotwired/stimulus"
import { Mp4Export } from "../modules/export_mp4"

// Controls the MP4 export panel for a single variant.
// Attach with: data-controller="export-mp4" on the export card or container.
export default class extends Controller {
  connect() {
    this.instance = new Mp4Export()
    this.instance.init()
  }

  disconnect() {
    // Restore viewer settings if the helper is available
    if (typeof window.reset_viewer_settings === "function") {
      try {
        window.reset_viewer_settings()
      } catch (e) {
        console.warn("[export-mp4] Failed to reset viewer settings", e)
      }
    }
  }
}

